import script from "./Loading.vue?vue&type=script&lang=ts&setup=true"
export * from "./Loading.vue?vue&type=script&lang=ts&setup=true"

import "./Loading.vue?vue&type=style&index=0&id=f606d5a8&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f606d5a8"]])

export default __exports__